import React from 'react'
import { styled } from '@mui/material'
import { keyframes } from '@mui/system'

const DOTS = [
    { color: '#007DB6', delay: '0s' },
    { color: '#008FB2', delay: '0.2s' },
    { color: '#009B9E', delay: '0.4s' },
    { color: '#00A77D', delay: '0.6s' },
    { color: '#00B247', delay: '0.8s' },
    { color: '#5AB027', delay: '1.0s' },
    { color: '#A0B61E', delay: '1.2s' },
]

const LABELS = {
    project: 'loading data',
    scanner: 'loading experience',
}

const pulse = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`

const Container = styled('div')({
    position: 'absolute',
    bottom: '120px',
    left: 'calc(50vw - 120px)',
    width: '240px',
    height: '62px',
})

const Label = styled('h2')({
    margin: 0,
    color: '#fff',
    lineHeight: '30px',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
    letterSpacing: '2px',
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.6)',
})

const Dots = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
})

const Dot = styled('span', {
    shouldForwardProp: (prop) => prop !== 'color' && prop !== 'delay',
})(({ color, delay }) => ({
    display: 'inline-block',
    width: '22px',
    height: '22px',
    margin: '5px 6px',
    backgroundColor: color,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.6)',
    animation: `${pulse} 1s infinite alternate`,
    animationDelay: delay,
}))

function DotSpinner({ variant = 'project' }) {
    const label = variant === 'project' ? LABELS.project : LABELS.scanner

    return (
        <Container role="status" aria-live="polite">
            <Label>{label}</Label>
            <Dots aria-hidden>
                {DOTS.map(({ color, delay }) => (
                    <Dot key={color} color={color} delay={delay} />
                ))}
            </Dots>
        </Container>
    )
}

export { DotSpinner }
